import { useEffect, useContext } from 'react';
import CmsDetailsContext from '../Context/CmsDetails/CmsDetailsContext';

const useTheme = () => {
  const { darkMode } = useContext(CmsDetailsContext);
  const theme = darkMode ? 'theme--dark' : 'theme--light';

  useEffect(() => {
    document.body.classList.remove('theme--light', 'theme--dark');
    document.body.classList.add(theme);
  }, [theme]);

  return theme;
};

export default useTheme;